type adgColorRecord = Record<string, string>;

const rawColors = {
  n0: '#ffffff',
  n10: '#fafbfc',
  n20: '#f4f5f7',
  n30: '#ebecf0',
  n40: '#dfe1e5',
  n50: '#c1c7d0',
  n60: '#b3bac5',
  n70: '#a5adba',
  n80: '#97a0af',
  n90: '#8993a4',
  n100: '#7a869a',
  n200: '#6c798f',
  n300: '#5e6c84',
  n400: '#505f79',
  n500: '#42526e',
  n600: '#344563',
  n700: '#253858',
  n800: '#172b4d',
  n900: '#091e42',
  y500: '#ff8b00',
  y400: '#ff991f',
  y300: '#ffab00',
  y200: '#ffc400',
  y100: '#ffe380',
  y75: '#fff0b2',
  y50: '#fffae5',
  g500: '#006644',
  g400: '#00875a',
  g300: '#36b37e',
  g200: '#57d9a3',
  g100: '#79f2c0',
  g75: '#abf5d1',
  g50: '#e3fcef',
  t500: '#008da6',
  t400: '#00a3bf',
  t300: '#00b8d9',
  t200: '#00c7e5',
  t100: '#79e2f2',
  t75: '#b3f5ff',
  t50: '#e6fcff',
  b500: '#0049b0',
  b400: '#0052cc',
  b300: '#0065ff',
  b200: '#2684ff',
  b100: '#4c9aff',
  b75: '#b2d4ff',
  b50: '#deebff',
  r500: '#bf2600',
  r400: '#de350b',
  r300: '#ff5630',
  r200: '#ff7452',
  r100: '#ff8f73',
  r75: '#ffbdad',
  r50: '#ffebe5',
  p500: '#403294',
  p400: '#5243aa',
  p300: '#6554c0',
  p200: '#8777d9',
  p100: '#998dd9',
  p75: '#c0b6f2',
  p50: '#eae6ff'
} as const;

const adgColors: adgColorRecord = Object.freeze(rawColors);

export type ExportableAdgColorTypes = keyof typeof rawColors;

export type adgColorsKeys = keyof typeof adgColors;

export const getColor = (colorId: adgColorsKeys) => {
  return adgColors[`${colorId.toLowerCase()}`] || '';
};
